/*
 * @Author: Teemo Ding
 * @Date: 2021-09-30 09:33:42
 * @LastEditTime: 2022-06-10 09:36:54
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelTax/TaxSetting/index.tsx
 */

import { Checkbox, RadioGroup, RadioItem } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { TaxApplyType, TaxInclusionType } from '@/src/types/common/tax';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Form } from 'antd';
import React from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import TaxRules from 'src/constrains/TaxRules';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const TaxSetting = ({
  disabled,
  disableEdit,
}: {
  disabled?: boolean;
  disableEdit?: boolean;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelTax.index.taxSetting')}>
      {disabled ? null : (
        <React.Fragment>
          <Form.Item
            name='taxInclusion'
            className={css.domainExclusive}
            initialValue={TaxInclusionType.Exclusive}>
            <RadioGroup disabled={disableEdit}>
              <div className={css.radioItem}>
                <RadioItem value={TaxInclusionType.Exclusive}>
                  {getI18n('salesChannelTax.index.taxExclusive')}
                </RadioItem>
                <span className={css.exclusive}>
                  {getI18n(
                    'salesChannelTax.index.theproductpricewillbetaxexclusive',
                  )}
                </span>
              </div>
              <div className={css.radioItem}>
                <RadioItem value={TaxInclusionType.Inclusive}>
                  {getI18n('salesChannelTax.index.taxInclusive')}
                </RadioItem>
                <span className={css.exclusive}>
                  {getI18n(
                    'salesChannelTax.index.theproductpricewillbetaxinclusive',
                  )}
                </span>
              </div>
              <div className={css.radioItem}>
                <RadioItem value={TaxInclusionType.Free}>
                  {getI18n('salesChannelTax.index.taxFree')}
                </RadioItem>
                <span className={css.exclusive}>
                  {getI18n(
                    'salesChannelTax.index.theproductpricewillbetaxfree',
                  )}
                </span>
              </div>
            </RadioGroup>
          </Form.Item>
          <Form.Item name='taxRulesEnabled' valuePropName='checked'>
            <Checkbox disabled={disableEdit}>
              {getI18n('salesChannelTax.index.chargetaxonorderleve')}{' '}
              <WhiteBackgroundTooltip
                overlayClassName={css.overlayClassName}
                title={
                  <TooltipContainer>
                    <TooltipTitle>
                      {getI18n('salesChannelTax.index.chargetaxonorderlevel')}
                    </TooltipTitle>
                    <TooltipContent>
                      {getI18n(
                        'salesChannelTax.index.chargetaxonorderlevelContent',
                      )}
                    </TooltipContent>
                  </TooltipContainer>
                }
                placement='rightTop' //overlayClassName
              >
                <QuestionCircleFilled className={css.icon} />
              </WhiteBackgroundTooltip>
            </Checkbox>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(p, c) => p.taxRulesEnabled !== c.taxRulesEnabled}>
            {({ getFieldValue }: any) =>
              getFieldValue('taxRulesEnabled') && (
                <TaxRules
                  applyTypes={[TaxApplyType.Order]}
                  disabled={disableEdit}
                />
              )
            }
          </Form.Item>
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};

export default TaxSetting;
